var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPending48Filled = function SvgIconPending48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm-6.06 18.29c-.88.88-2.3.88-3.18 0-.88-.88-.88-2.3 0-3.18.88-.88 2.3-.88 3.18 0 .88.88.88 2.3 0 3.18Zm4.47-3.18c.88-.88 2.3-.88 3.18 0 .88.88.88 2.3 0 3.18-.88.88-2.3.88-3.18 0-.88-.88-.88-2.3 0-3.18Zm7.65 3.18c-.88-.88-.88-2.3 0-3.18.88-.88 2.3-.88 3.18 0 .88.88.88 2.3 0 3.18-.88.88-2.3.88-3.18 0Z",
    fill: "current"
  })));
};
export default SvgIconPending48Filled;